import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import {
  Circle as BulletActive,
  ExpandMoreRounded as ExpandIcon,
  PolicyOutlined as AuditIcon,
} from "@mui/icons-material";
import { useSelector } from "react-redux";

const auditItemsConfig = [
  {
    permission: 3,
    label: "Auditing of Voucher",
    to: "/audit/inspect-voucher",
    notificationKey: "Auditing of Voucher",
    notificationArrayProp: "transactions",
    isLoadingProp: "isTransactionsLoading",
    notificationValue: "pending",
  },
  {
    permission: 5,
    label: "Auditing of Cheque",
    to: "/audit/chequing",
    notificationKey: "Auditing of Cheque",
    notificationArrayProp: "cheque",
    isLoadingProp: "isChequeLoading",
    notificationValue: "pending",
  },
  {
    permission: 36,
    label: "Monitoring of Auditing Cheque",
    to: "/audit/monitor/audit-chequing",
    notificationKey: "Monitoring of Auditing Cheque",
    notificationArrayProp: "transactions",
    isLoadingProp: "isTransactionsLoading",
    notificationValue: "pending",
  },
  {
    permission: 5,
    label: "Returned Audited Cheque",
    to: "/audit/return/audited-cheque",
    notificationKey: "Auditing of Cheque",
    notificationArrayProp: "cheque",
    isLoadingProp: "isChequeLoading",
    notificationValue: "return",
  },
];

const SidebarAuditDropdown = ({
  activeDropdown,
  user,
  transactions,
  cheque,
  shouldDisplayDotNotification,
  isTransactionsLoading,
  isChequeLoading,
  RouterLink,
  DisplayBubbleNotification,
}) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/audit/gi));

  const allNotifications = {
    "Auditing of Voucher": transactions,
    "Auditing of Cheque": cheque,
    "Monitoring of Auditing Cheque": transactions,
  };

  const allLoadingStates = {
    isTransactionsLoading,
    isChequeLoading,
  };

  return (
    <Accordion defaultExpanded={/audit/i.test(user.role)} elevation={0} square disableGutters>
      <AccordionSummary
        className={
          isActiveDropdown
            ? `FstoSidebarActiveDropdown-root ${color}`
            : `FstoSidebarDropdown-root  ${color}`
        }
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <AuditIcon />
        <Typography variant="sidebar">Audit</Typography>
        {auditItemsConfig.some(
          (item) =>
            user.permissions.includes(item.permission) &&
            shouldDisplayDotNotification(
              allNotifications[item.notificationKey],
              item.notificationKey
            )
        ) ? (
          <BulletActive className="FstoSidebarActiveNotif-root" />
        ) : null}
      </AccordionSummary>

      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {auditItemsConfig.map(
          (item) =>
            user.permissions.includes(item.permission) && (
              <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
                {item.label}
                {!allLoadingStates[item.isLoadingProp] && (
                  <DisplayBubbleNotification
                    notificationArray={allNotifications[item.notificationKey]}
                    permission={item.notificationKey}
                    value={item.notificationValue}
                  />
                )}
              </RouterLink>
            )
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarAuditDropdown;
